import { ChapterLabel, Reveal, ArrowButton } from "@/components/landing/Reveal";
import { waLink, WA_MESSAGES } from "@/lib/site";

const STEPS = [
    {
        n: "01",
        title: "Tell Us Your Plans",
        copy: "Send us your destination, date, number of guests and preferred club or vibe.",
        testId: "step-tell-us",
    },
    {
        n: "02",
        title: "Choose Your Experience",
        copy: "We'll share suitable VIP table and package options.",
        testId: "step-choose",
    },
    {
        n: "03",
        title: "Confirm & Enjoy",
        copy: "Confirm your booking and let us handle the details.",
        testId: "step-confirm",
    },
];

const HowItWorks = () => (
    <section
        id="how-it-works"
        data-testid="how-it-works-section"
        className="border-y border-white/10 bg-[#0A0A0A]"
    >
        <div className="mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-36">
            <Reveal>
                <ChapterLabel number="Nº 04" title="The Process" testId="how-it-works-label" />
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="mt-8 max-w-3xl font-serif text-3xl font-medium leading-tight tracking-tight text-ivory md:text-5xl">
                    FROM WHATSAPP TO VIP TABLE{" "}
                    <span className="italic text-gold">IN 3 STEPS.</span>
                </h2>
            </Reveal>

            <div className="mt-16 grid gap-10 md:grid-cols-3 md:gap-12">
                {STEPS.map((s, i) => (
                    <Reveal key={s.n} delay={0.1 + i * 0.12}>
                        <div
                            data-testid={s.testId}
                            className="group border-t border-white/10 pt-8 transition-colors duration-500 hover:border-gold/50"
                        >
                            <span className="font-serif text-6xl font-light italic text-gold/25 transition-colors duration-500 group-hover:text-gold/60 md:text-7xl">
                                {s.n}
                            </span>
                            <h3 className="mt-6 text-xs font-bold uppercase tracking-[0.25em] text-ivory">
                                {s.title}
                            </h3>
                            <p className="mt-4 text-sm leading-relaxed text-muted">
                                {s.copy}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.2}>
                <div className="mt-16">
                    <ArrowButton
                        testId="how-it-works-start-booking-btn"
                        href={waLink(WA_MESSAGES.booking)}
                    >
                        Start My Booking
                    </ArrowButton>
                </div>
            </Reveal>
        </div>
    </section>
);

export default HowItWorks;
